module.exports = __webpack_public_path__ + "static/media/muffins.d7eb80b1.svg";